export default __webpack_public_path__ + "./images/how-1.webp";